/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForOciConsolidatedChargesReport extends models.ConfigurationForFinOpsConsolidatedReport {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForOciConsolidatedChargesReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForOciConsolidatedChargesReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForOciConsolidatedChargesReport>): ConfigurationForOciConsolidatedChargesReport {
        let obj = Object.assign(new ConfigurationForOciConsolidatedChargesReport(), model);
        ConfigurationForOciConsolidatedChargesReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForOciConsolidatedChargesReport>): ConfigurationForOciConsolidatedChargesReport {
        if (!model) return null;
        return ConfigurationForOciConsolidatedChargesReport.newInstance(<ConfigurationForOciConsolidatedChargesReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForOciConsolidatedChargesReport) {
        if (!obj) return;

        models.ConfigurationForOciConsolidatedChargesReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForOciConsolidatedChargesReport): boolean {
        if (models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForOciConsolidatedChargesReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
